// Master contact list (email -> name), stored in the browser so exports can
// fill in names even for historical campaigns whose names were never persisted
// server-side. Send-time recipients (campaign.recipients) take priority over
// this list when both are available.
import Papa from "papaparse";

const KEY = "hb-contacts";

export const loadContacts = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

export const saveContacts = (map) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    /* ignore quota errors */
  }
};

export const contactCount = () => Object.keys(loadContacts()).length;

// Turn a recipients array [{email, name}] into a lowercased email -> name map.
export const toNameMap = (recipients = []) => {
  const m = {};
  (recipients || []).forEach((r) => {
    const e = (r?.email || "").toLowerCase().trim();
    if (e && r?.name) m[e] = r.name;
  });
  return m;
};

// First non-empty match across the provided maps (priority order).
export const resolveName = (email, ...maps) => {
  const e = (email || "").toLowerCase().trim();
  for (const m of maps) {
    if (m && m[e]) return m[e];
  }
  return "";
};

// Parse an uploaded email,name CSV into a lowercased email -> name map.
export const parseContactsCsv = (file) =>
  new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      transformHeader: (h) => (h || "").trim(),
      complete: (res) => {
        const fields = (res.meta.fields || []).map((f) => (f || "").trim());
        const findKey = (needles) =>
          fields.find((f) => {
            const l = f.toLowerCase();
            return needles.some((n) => l.includes(n));
          });
        const emailKey = findKey(["email", "e-mail", "mail"]);
        const nameKey = findKey(["name"]);
        if (!emailKey) {
          reject(new Error("No email column found in that CSV"));
          return;
        }
        const map = {};
        res.data.forEach((row) => {
          const e = (row[emailKey] || "").toLowerCase().trim();
          if (e) map[e] = nameKey ? (row[nameKey] || "").trim() : "";
        });
        resolve(map);
      },
      error: reject,
    });
  });
